import gql from "graphql-tag";

export const DeleteList_GQL = gql`
  mutation($inst_id: String!, $account_id: String!, $id: String!) {
    listDelete(instId: $inst_id, accountId: $account_id, id: $id) {
      data {
        updatedAt
        id
        accountId
        system
        shared
        name
        deletedAt
        orderBy
        attributes
      }
      message
      code
    }
  }
`;
